export default __webpack_public_path__ + "static/media/DISENOPRENSAMOTOR.e1854fbe.webp";